export default {
  title: 'Learners',
  desc: 'Add, track, and manage your learners in one place.',
  empty: 'No learners found!',
  empty_cta: 'Create',
  empty_cta_import: 'Import Learner!',
  deactivate: 'Deactivate account',
  activate: 'Activate account',
  unlock: 'Unlock account',
  deactivated: 'Deactivated',
  filters: {
    add: 'Add Filter',
    conditions: {
      title: 'Add Filters',
      operand: 'Operand',
      operator: 'Operator',
      value: 'Value',
      apply: 'Apply & Search',
      error: 'One or many fields are empty'
    }
  },
  tabs: {
    all: 'All',
    academy: 'Academy',
    knowledge_base: 'Knowledge Base'
  },
  empty: {
    title: 'No learners found',
    filtered: 'No learners match the selected group or filters. Try changing them.',
    all: 'Learners will show up here once they sign up or you add them.',
    academy: 'No learner has enrolled in a course yet.',
    knowledge_base: 'No learner has visited this knowledge base yet.',
    clear: 'Clear Filters'
  },
  table: {
    learner_details: 'Learner',
    email: 'Email',
    company: 'Company',
    courses_enrolled: 'Courses Overview',
    courses_completed: 'Courses Completed',
    courses_certified: 'Courses Certified',
    total_engagement_time: 'Total Engagement Time',
    created_at: 'Created',
    joined_at: 'Joined',
    academy_joined_at: 'Academy Joined',
    last_accessed: 'Last Accessed',
    last_active: 'Last Active',
    last_visited: 'Last Visited',
    last_course_activity: 'Last Course Activity',
    verified: 'Verified',
    active_medium: 'Active Medium',
    pending_reviews: 'Pending Reviews',
    to_review: '%{count} to review',
    actions: 'Actions',
    action: 'Action',
    footer_display: `Showing %{min_count} - %{max_count} of %{count}`,
    footer_page: `Page %{page} of %{pages}`,
    mediums: {
      academy: 'Academy',
      knowledge_base: 'KB',
      knowledge_base_full: 'Knowledge Base',
      in_app: 'In-app',
      embed: 'Embed',
      link: 'Link'
    },
    verified_status: {
      verified: 'Verified',
      verify: 'Verify',
      not_verified: 'Not verified',
      tooltip: 'Mark this email as valid to verify the learner',
      not_verified_tooltip: 'This email has not been checked yet. It is verified automatically the first time we email this learner.',
      success: 'Learner verified successfully'
    },
    courses: {
      title: 'Courses (%{count})',
      enrolled: '%{count} enrolled',
      done: '%{count} done',
      completed: '%{count} completed',
      in_progress: '%{count} in progress',
      not_started: '%{count} not started',
      certified: 'Certification course'
    },
    certificates: {
      header: 'Certificates',
      title: 'Certificates (%{count})',
      issued_to: 'Issued to %{name}'
    },
    reviews: {
      header: 'Reviews',
      title: 'Reviews (%{count})'
    }
  },
  sort_by: {
    created_at: 'Created At',
    last_accessed_at: 'Last Accessed At'
  },
  button: {
    create: 'Create New Learner',
    add: 'Create Learner',
    add_or_import: 'Add / Import',
    import: 'Import',
    export: 'Export',
    bulk_edit: 'Edit',
    clear: 'Clear selection'
  },
  create: {
    title: 'Create New Learner',
    email: 'Email',
    first_name: 'First Name',
    last_name: 'Last Name',
    company: 'Company',
    invite_to_academy: 'Send an invite to access academy',
    invite_to_video_hub: 'Send an invite to access Knowledge Hub'
  },
  import: {
    title: 'Bulk Import Learners',
    desc: 'Bulk Import Learners',
    file_upload_label: "Upload CSV file",
    download_sample: 'Download sample csv',
    detailed_log: 'for detailed error log',
    click: 'Click here',
    loading:
      'Your data is being imported. This might take few seconds. Please wait...',
    success: `%{count} record(s) have been inserted successfully`,
    error: `Error %{message} in %{count} record(s)`,
    note: `Note: Your CSV data file should contain all the columns specific to the operation you are performing. The sample CSV file has most of the columns required for the operation.`
  },
  export: {
    title: 'Export learners',
    desc: `A CSV file containing the learners' information will be sent to your email.`
  },
  detail: {
    title: 'Learner Details',
    name: 'Name',
    email: 'Email',
    company: 'Company Name',
    created_at: 'Created At',
    joined_at: 'Joined At',
    last_accessed: 'Last Accessed At',
    nav: `(%{min_count} / %{max_count})`,
    user_properties: {
      title: 'User Engagement',
      engagement_time: 'Total engagement time',
      engagement_videos: 'Total video views'
    },
    activity: {
      title: 'Activity Log',
      subtitle: 'Recent account events.',
      created_at: 'Created at %{date}',
      joined_at: 'Joined on %{date}',
      academy_joined_at: 'Academy Joined at %{date}',
      last_accessed: 'Last accessed at %{date}',
      last_accessed_label: 'Last accessed',
      account_created: 'Account created',
      academy_joined: 'Academy joined',
      hub_joined: 'Hub joined',
      active_surfaces: 'Active surfaces'
    },
    email_log: {
      title: 'Email Log',
      subtitle: 'Notifications sent to this learner.',
      sent_on: 'Sent On',
      subject: 'Subject',
      notification_name: 'Notification'
    },
    task: {
      pending_tasks: 'Pending tasks',
      course_title: 'Course',
      task_title: 'Task',
      action: 'Action',
      task_type: 'Task type',
      learner_response: 'Learner response',
      created_on: 'Created on',
      evaluate_task: 'Evaluate task',
      no_pending_tasks: 'No pending tasks yet',
      approve: 'Approve Task',
      redo: 'Redo Task',
      redo_tooltip: 'Will allow learner to redo the task.',
      comment_placeholder: 'Enter your comment here...',
      comment_required: 'Please enter your comment'
    },
    analytics: {
      engaged_videos: {
        title: 'Engaged Videos & Guides',
        no_of_visits: 'Number of views',
        duration_spent: 'Engagement Time',
        empty: 'No video visits'
      },
      engaged_flows: {
        title: 'Engaged Collections',
        no_of_visits: 'Number of Visits',
        duration_spent: 'Engagement Time',
        empty: 'No collections watched yet',
        contains: 'Contains'
      },
      course_enrollments: {
        title: 'Course Enrollments',
        empty: 'No Enrollments yet',
        enrolled: 'Enrolled on',
        completed: 'Completed on',
        lessons_completed: 'Lessons completed',
        certification_completed_on: 'Certification completed on',
        view_assessment_attempts: 'View Assessment attempts',
        view_quiz_attempts: 'View Quiz attempts',
        download_quiz_attempts: 'Download Quiz attempts',
        quiz_summary: 'Quiz Summary',
        exam_summary: 'Exam Summary',
        certified: 'Certified',
        last_assessment_attempts: 'Last %{count} attempts',
        last_assessment_attempt: 'Last %{count} attempt',
        attempt: 'Attempt',
        created_at: 'Created at',
        score: 'Score',
        state: 'State',
        passed: 'Passed',
        failed: 'Failed',
        timed_out: 'Timed out',
        no_attempts: 'No attempts found.',
        responses: 'Responses',
        download: 'Download',
        fee: 'Fee paid'
      }
    },
    course_assignments: {
      title: 'Course Assignments',
      empty: 'No course has been assigned directly to this learner.',
      add: 'Assign'
    },
    back: 'Back to Learners',
    external_id: 'External ID',
    custom_fields: 'Custom Fields',
    edit: 'Edit',
    deactivate: 'Deactivate',
    metrics: {
      company: 'Company',
      engagement_time: 'Total Engagement Time',
      last_active: 'Last Active',
      created: 'Created'
    },
    summary: {
      title: 'Engagement Summary',
      subtitle: 'A quick snapshot across all surfaces.',
      content: 'Content Engaged',
      content_desc: '%{videos} Videos & %{guides} Guides',
      academy: 'Academy',
      academy_desc: 'Courses completed'
    },
    content: {
      title: 'Content Engagement',
      subtitle: 'Videos and guides this learner has engaged with.',
      type: 'Type',
      content: 'Content',
      views: 'Views',
      engagement_time: 'Engagement Time',
      medium: 'Medium',
      referrer: 'Referrer',
      status: 'Status',
      video: 'Video',
      guide: 'Guide',
      completed: 'Completed',
      empty: 'No content engagement yet'
    },
    enrolments: {
      title: 'Course Enrollments',
      subtitle: '%{count} courses · joined %{joined}',
      course: 'Course',
      status: 'Status',
      enrolled_on: 'Enrolled On',
      completed_on: 'Completed On',
      certificate: 'Certificate',
      reviews: 'Reviews',
      reviews_count: '%{count} reviews',
      reviews_count_one: '%{count} review',
      reviews_empty: 'No reviews for this course yet',
      action: 'Actions',
      completed: 'Completed',
      in_progress: 'In progress',
      not_started: 'Not started',
      access_restricted: 'Access Restricted',
      access_restricted_tooltip: 'Access restricted after multiple failed quiz attempts.',
      view_certificate: 'View',
      re_enroll: 'Re-enrol Learners',
      untitled: 'Untitled course',
      lessons_completed: '%{completed} of %{total} lessons completed',
      untitled_lesson: 'Untitled lesson',
      empty: 'No enrollments yet'
    },
    pending: {
      title: 'Pending Task Reviews',
      subtitle: '%{count} tasks awaiting review.',
      task: 'Title',
      course: 'Course name',
      type: 'Type',
      review: 'Review',
      empty: 'No tasks awaiting review'
    }
  },
  actions: {
    invite_user: {
      title: 'Invite Learner to Knowledge Hub',
      desc:
        'A link will be sent via email, through which the learner can login to your Knowledge Hub'
    },
    academy_invite_user: {
      title: 'Invite Learner to Academy',
      desc:
        'A link will be sent via email, through which the learner can login to your Academy',
      already_invited: 'Learner has already joined the academy. '
    },
    share_hub_url: {
      title: 'Knowledge Hub',
      desc:
        'Share a Knowkedge Base via a unique URL created for this learner. This allows you to track engagement specific to this learner.',
      copy: 'Copy Share Link'
    },
    share_academy_url: {
      title: 'Academy'
    },
    share_video: {
      title: 'Video',
      desc:
        'Share a video using a unique URL and track engagements specific to this learner',
      desc_long:
        'Share a video via a unique URL created for this learner. This allows you to track engagement specific to this learner.',
      note:
        'This unique url only helps us to track engagements and does not authenticate the learner.',
      select: 'Select Video',
      copy: 'Copy Share Link'
    },
    share_collection: {
      title: 'Collection',
      desc:
        'Share a collection using a unique URL and track engagements specific to this learner',
      desc_long:
        'Share a collection via a unique URL created for this learner. This allows you to track engagement specific to this learner.',
      note:
        'This unique url is only for tracking engagements and does not authenticate the learner.',
      select: 'Select collection',
      copy: 'Copy Share Link'
    },
    create: 'Create New Learner',
    edit: 'Edit Learner',
    enroll: {
      button: 'Enrol',
      button_in_course: 'Enrol in course',
      title: 'Enrol in Courses',
      desc: 'Assign courses to %{name}. They will be notified based on your academy settings.',
      confirm: 'Enrol',
      empty: 'No live courses to assign',
      success: 'Courses assigned successfully'
    },
    delete: {
      title: 'Delete Learner',
      desc:
        'This action cannot be undone. All learner data, progress history, and associated course enrollments will be permanently removed from the system.',
      not_allowed:
        'The learner cannot be deleted as they have been issued certificates.'
    },
    deactivate: {
      title: 'Deactivate Learner',
      desc:
        'The learner will be deactivated. They will not be able to login to your Knowledge Hub or Academy.'
    },
    activate: {
      title: 'Activate Learner',
      desc:
        'The learner will be activated.'
    },
    reset_attempts: {
      unlock: 'Allow Access',
      title: 'Access Restricted',
      desc: `
      Learner has exceeded the attempt limit for a quiz or assessment.
      `,
      footer_desc: 'By Allowing access, you will reset the attempt limit based on the course settings for this learner.'
    },
    pending_tasks: {
      taks: 'Pending tasks',
      untitled_task: 'Untitled task'
    }
  },
  banner: {
    approval: 'Awaiting learner approval',
    reject: 'Reject',
    approve: 'Approve',
    rejected: 'Learner rejected',
    approved: 'Learner approved',
    unlocked: 'Learner unlocked successfully'
  },
  email_verification: {
    title: 'Are you sure to mark this email as valid?',
    cancel: 'Cancel',
    confirm: 'Mark as Valid'
  },
  re_enroll_course: {
    re_enroll_button: 'Re-enroll',
    title: 'Are you sure you want to re-enroll this learner?',
    description: "The learner's course progress will be reset upon re-enrollment and the history will not be retained.",
    success: 'Course Re-enrolled Successfully',
    save_button: 'Yes, Re-enroll',
    cancel_button: 'Cancel',
    send_email: 'Send a email notification to the learner'
  },
  bulk: {
    select_all_learners: 'Select all %{count} learner(s)',
    clear: 'Clear selection',
    all_learners_selected: `All the learners are selected`,
    all_learners_in_page_selected: 'All %{count} learner(s) on this page are selected',
    learners_selected: 'Selected %{count} learner(s)',
    count: 'Type the number of learner(s) you are %{activity} below',
    count_error: 'Type the correct number of learner(s) to proceed',
    activating: 'activating',
    deactivating: 'deactivating',
    bulk_action_title: '%{activity} %{count} Learner(s)',
    delete_note: 'If the learner has any certifications, this will only deactive the learner.',
    empty_note: 'Leaving the value blank will remove the existing value.',
    activate: 'Activate',
    deactivate: 'Deactivate',
    update: 'Update',
    delete: 'Delete',
    deleting: 'deleting',
    changing: 'changing',
    validate: 'Validate',
    desc: 'Type the number of learner(s) you are validating below'
  }
};
